module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5cdf5ce5126eb158a65b2c110e249b11.png";